module.exports = __webpack_public_path__ + "assets/assets/images/icons/arrow-right-emergency.35692532.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/arrow-right-emergency.svg
// module id = 416
// module chunks = 0